import { Box, Button, Container, Grid } from "@mui/material";


import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

import { SellerData } from "../../data/SellerData";
import S_single from "./s_mobile";
import S_sdesk from "./s_singledesk";

export default function SellerProducts() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const renderProducts = SellerData.map((product) => (
    <Grid item key={product.id} xs={2} sm={4} md={4} display="flex" flexDirection={'column'} alignItems="center">
      {matches ? (
        <S_single product={product} matches={matches} />
      ) : (
        <S_sdesk product={product} matches={matches} />
      )}
    </Grid>
  ));
  return (
    <Container>
      <Grid        
        container
        spacing={{ xs: 2, md: 3 }}
        justifyContent="center"
        sx={{ margin: `20px 4px 10px 4px` }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        {renderProducts}
      </Grid>
    </Container>
  );
}
